import Swal from 'sweetalert2'

export default {
  props: ['time', 'saleTypeText'],
  data() {
    return {
      timerInterval:'',
      cdt: {
        sku_id: 2,
        image_name: 'credit',
        color: 'badge-danger',
        goto: 'CreditCard',
        image_path: require('../../assets/visa.png'),
        title_name: [
          {
            name_id: 0,
            name: 'Credit Card',
            say: 'Payment By Credit Card'
          },
          {
            name_id: 1,
            name: 'บัตรเครดิต',
            say: 'ชำระเงินผ่านบัตรเครดิต'
          },
          {
            name_id: 2,
            name: '信用卡',
            say: '信用卡付款'
          }
        ]
      }
    }
  },
  methods: {
    // checkTime() {
    //   this.$store.state.loopPCR = setInterval(() => {
    //     console.log('credit time = ' + this.time)
    //     switch (this.time) {
    //       case 100: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 80: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 60: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 40: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //       case 20: this.$socket.sendObj({
    //         command: 'edc_cancel'
    //       })
    //         console.log('edc_cancel')
    //         this.check_edc()
    //         break
    //     }
    //     if (this.time == 0) {
    //       this.$socket.sendObj({
    //         command: 'receive_close'
    //       })
    //       clearInterval(this.$store.state.loopPCR)
    //     }
    //   }, 1000)
    // },
    check_edc() {
      // this.$socket.sendObj({
      //   command: 'edc_status'
      // })
      // if (this.$store.state.edc_status === false) {
      //   let text = ''
      //   let title = ''
      //   switch (this.lang) {
      //     case 0:
      //       text = 'Credit card receivers are not available yet.'
      //       title = 'Warning'
      //       break
      //     case 2:
      //       text = '信用卡接收器尚不可用。'
      //       title = '通知'
      //       break
      //     default:
      //       text = 'เครื่องรับบัตรเครดิตยังไม่พร้อมใช้งาน'
      //       title = 'แจ้งเตือน'
      //       break
      //   }
      //   Swal.fire({
      //     title: title,
      //     text: text,
      //     type: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#3085d6',
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'OK'
      //   }).then((result) => {
      //     if (result.value) {
      //       this.$store.state.timeOut = 0
      //       this.$router.go(-1)
      //     }
      //   })
      // } else {
        var obj = {
          command: 'edc_sale',
          data: '{"reference_no\":\"KL_001\", \"developer_id\":\"8237DB87A0\", \"amount\":' + parseInt(this.$store.state.total + '00') + '}'
        }
        this.$socket.sendObj(obj)
      // }
    },
    Resend_edc() {
      this.$store.state.edc_step = 0
      var obj = {
        command: 'edc_sale',
        data: '{"reference_no\":\"KL_001\", \"developer_id\":\"8237DB87A0\", \"amount\":' + parseInt(this.$store.state.total + '00') + '}'
      }
      this.$socket.sendObj(obj)
      Swal.fire({
        title: 'กรุณาเสียบบัตรเครดิตของท่าน',
        text: 'Please insert your card.',
        type: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'ยกเลิก',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.timerInterval = setInterval(() => {
            console.log("timerInterval")
            if (this.$store.state.edc_step == 1){
              clearInterval(this.timerInterval)
              this.$store.state.edc_step = 0
              this.closePop()
            }
            if (this.$store.state.PaymentType == 2){
              clearInterval(this.timerInterval)
              this.$store.state.edc_step = 0
              Swal.close()
            }
          }, 500)
        },
        // onClose: () => {
        //   clearInterval(this.timerInterval)
        // }
      }).then((result) => {
        clearInterval(this.timerInterval)
        this.$socket.sendObj({
          command: 'edc_cancel'
        })
      })
    },
    closePop() {
      Swal.fire({
        position: 'center',
        type: 'error',
        title: 'Time Out',
        showConfirmButton: false,
        timer: 2000
      })
    },
    payment() {
      if (this.$store.state.edc_status === true) {
        if (parseInt(this.$store.state.AmountPayment) > 0) {
          this.$router.push({
            name: 'ProcessCredit'
          })
        }
      } else {
        let text = ''
        let title = ''
        switch (this.lang) {
          case 0:
            text = 'Credit card receivers are not available yet.'
            title = 'Warning'
            break
          case 2:
            text = '信用卡接收器尚不可用。'
            title = '通知'
            break
          default:
            text = 'เครื่องรับบัตรเครดิตยังไม่พร้อมใช้งาน'
            title = 'แจ้งเตือน'
            break
        }
        Swal.fire({
          title: title,
          text: text,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.value) {
            this.$socket.sendObj({
              command: 'edc_status'
            })
          }
        })
      }
    }
  },
  mounted() {
    console.log('credit card ready!!')
    // this.$socket.sendObj({
    //   command: 'edc_cancel'
    // })
    // setTimeout(() => {
    // this.check_edc()
    // },2000)
    // this.checkTime()
  }
}



// WEBPACK FOOTER //
// ./src/js/type/credit.js